{
  "profiles": [
    { "id": "rookie", "skill": 0.2, "bravery": 0.4 },
    { "id": "veteran", "skill": 0.55, "bravery": 0.7 },
    { "id": "ace", "skill": 0.9, "bravery": 0.9 },
    { "id": "civilian", "skill": 0.2, "bravery": 0.1 }
  ],
  "tuning": {
    "engageRange": 4000,
    "holdMin": 150,
    "holdMax": 450,
    "antiJoustRange": 400,
    "antiJoustConeDeg": 25,
    "evadeSeconds": [0.8, 1.6],
    "evadeThrottle": 0.5,
    "fleeThrottle": 0.75,
    "jinkSeconds": [0.35, 0.8],
    "aimErrorDeg": [4, 0.5],
    "reactionDelay": [0.6, 0.15],
    "fleeHullFactor": 0.5,
    "avoidLookahead": 2,
    "avoidMinDistance": 150,
    "steering": { "turnGain": 2.5, "rollGain": 1.2, "rangeGain": 0.004, "avoidGain": 1.5 },
    "patrol": { "radius": 1500, "arriveDistance": 150, "throttle": 0.5 },
    "bands": {
      "L": { "engageRange": 2000, "holdMin": 1000, "holdMax": 1800, "evade": false, "antiJoust": false, "avoidRadii": 4 }
    }
  }
}
